import { find } from 'lodash';
import SMP_CONFIG from './smp_config';
import moment from 'moment';

const VEHICLE_SELECTION_CATALOG = 'CATALOG';
const VEHICLE_SELECTION_HSN_TSN = 'HSN_TSN';
const VEHICLE_SELECTION_VIN = 'VIN';
const getVehicleSelectionMethods = () => {
  if (
    SMP_CONFIG.applicationConfig &&
    SMP_CONFIG.applicationConfig.vehicleSelectionConfig &&
    SMP_CONFIG.applicationConfig.vehicleSelectionConfig.selectionMethods
  ) return SMP_CONFIG.applicationConfig.vehicleSelectionConfig.selectionMethods;

  return [];
};
const isVehicleSelectionMethodAllowed = (method) => {
  // Do not allow Vin tab is Vin identification is not allowed
  if (method === VEHICLE_SELECTION_VIN && !isVinIdentificationAllowed()) return false;

  return !!find(getVehicleSelectionMethods(), (it) => it === method);
};
const isVinIdentificationAllowed = () => {
  if (SMP_CONFIG.contextConfig && SMP_CONFIG.contextConfig.allowVinRequest) {
    return SMP_CONFIG.contextConfig.allowVinRequest;
  }
  return false;
};
const getDatConnectionConfig = () => {
  let datConnectionConfig = SMP_CONFIG.datConnectionConfig || { active: true };
  let active = datConnectionConfig.active;

  if (active) {
    return { active: true };
  } else {
    let now = moment().valueOf();
    let message = datConnectionConfig.message;

    let from = datConnectionConfig.from || {};
    from = from.time || 0;

    let to = datConnectionConfig.to || {};
    to = to.time || (now + 1);

    if (from <= now && now <= to) {
      return {
        active: false,
        message: message
      };
    } else {
      return { active: true };
    }
  }
}
export default {
  getVehicleSelectionMethods,
  isVehicleSelectionMethodAllowed,
  VEHICLE_SELECTION_CATALOG,
  VEHICLE_SELECTION_HSN_TSN,
  VEHICLE_SELECTION_VIN,
  isVinIdentificationAllowed,
  getDatConnectionConfig
};
